var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrangeQuote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 27,
    viewBox: "0 0 29 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 27,
    fill: "url(#pattern0_134_70)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_134_70",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_134_70",
    transform: "scale(0.0344828 0.037037)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_134_70",
    width: 29,
    height: 27,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAbCAMAAAC3FHQgAAAAAXNSR0IB2cksfwAAAUFQTFRF6W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W86porM6wAAAGt0Uk5TAAldw3VHrKs6wv+CHaP8WO4y1FT3fCrfvSzr9YoMxqExBbDjRn72Zkn780Hna6qDcq7V4BYHwD2XHvHHBNNaQI79NGBk8iNqVvAfaEz6p5aZnJA4uZpTCBhpLoz5K4iH+C1sidoltuwX6ulclpZdAAABVklEQVR4nJ3R3SvDURgH8O+3tlLemrdaDZMWbhZi3mKxC0UKeWm3kvxPLlyotRsXIklCTCOEUEgirZRdrLxtbPE7++33O+fnjufidJ7zOc9znjqECGqRhhJ2MiXOxT6PBN+kFWh3U5mcFvMTqjqYBL4/dC3lu7bJfzawgi/aWvSUVScT4nriNYeVjGtrOe+F1lC75OSt2dcTA1y81qet5wPcvJQTue+A2nM9oVer8pzJeRtvgLqTXMLmKzTwyMRWXsDhOjC0JAnvvizt4CmaGDG0+xgtO1L9h4BvG1LbuCk1EAU6NxTt4rrU/l2gZ01RP1elDm4BfSuKBrQPQvafFnUd+BK5/bGKYiojCnvDCC7JPjafqhgOWRQjqo5ywapjv1W8a8b439TS2aITmf+/K2otaqmtbp/HVFjRIKdDZmKbnMv+kRnkDJf17dBeWTqC2Xi5adHYD9AEayzwvFQrAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeQuote);
export default __webpack_public_path__ + "static/media/OrangeQuote.4c93e16cca608cd8289a6ea5e81e1ce7.svg";
export { ForwardRef as ReactComponent };